import { Editor } from "./Editor.js";
import { default as numeral } from "numeral";

export class NumBox extends Editor {

    constructor(parent, options = {}) {

        super(parent, options);

        const {
            format = (options && options.format) || '0',
            autofocus = (options && options.autofocus) || false,
        } = options;

        this.format = format;
        this.autofocus = autofocus;
    }

    initialize(parent, params) {

        control.initialize.call(this, parent, params);
        this.format = (params && params.format) || '0';
        this.autofocus = (params && params.autofocus) || false;
        return this;

    };

    formatValue(value) {

        return numeral(value).format(this.getFormat());

    };

    parseText(text) {

        return numeral(text).value();

    };

    isAutofocus() {

        return (typeof this.autofocus === 'function') ? this.autofocus.call(this) : this.autofocus;

    };

    getFormat() {

        return (typeof this.format == 'function') ? this.format.call(this) : this.format;

    };

    _render(r, vm) {

        if (!this.isVisible())
            return null;

        const renderer = r;

        var that = this,
            value = this.getValue(),
            style = this.getCss(),
            props = Object.assign({
                id: this.getId(),
                value: this.getValue(),
                readonly: (this.isReadOnly() || this.isDisabled()) && 'readonly',
                'data-focus': !(this.isDisabled() || this.isReadOnly()) && this.isAutofocus() ? 'auto' : null,
            }),
            params = {
                css: style,
                props,
                onFormatValue: (value) => that.formatValue(value),
                onParseText: (text) => that.parseText(text),
                onValueSet: (value) => that.changeValue(value),
            },
            oldParsedValue = '';

        if (this.immediateValueChange) {
            //props.onkeydown = onValuePossibleChange;
            props.onkeyup = onValuePossibleChange;
        }

        return renderer.textBox(value, params);

        function onValuePossibleChange(e, node) {
            var value = e.target.value,
                parsedValue = that.parseText(value);
            if (parsedValue == oldParsedValue)
                return;
            oldParsedValue = parsedValue;
            that.changeValue(parsedValue);
        };

    };

}